export function getFlightProgress(departureTime, arrivalTime, now = new Date()) {
  if (now < departureTime) return 0; // Not started
  if (now > arrivalTime) return 1;   // Finished
  const total = arrivalTime.getTime() - departureTime.getTime();
  const elapsed = now.getTime() - departureTime.getTime();
  return Math.min(Math.max(elapsed / total, 0), 1);
}
